import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { EventListData } from '~admin/model/event-list-data';
import { mapEventListData } from '~admin/model/event-list-data.mapper';
import { EventListResponseItem } from '~client/model/event-list-response-item';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type GetEventsTask = OneArgTask<boolean, EventListData[]>;

/**
 * Returns a list of all events without filters
 * @param showUpcomingEvents
 */
const performGetEvents = (showUpcomingEvents?: boolean): Observable<EventListResponseItem[]> =>
  apiClient.eventAdminController.getEvents$(showUpcomingEvents).pipe(pluck('eventList'));

export const getEventsTaskFactory = (): GetEventsTask =>
  rxTask<boolean, EventListData[]>((showUpcomingEvents?: boolean) =>
    performGetEvents(showUpcomingEvents).pipe(map(mapEventListData)),
  );



// WEBPACK FOOTER //
// ./interactor/event/perform-get-events.ts